import 'date-input-polyfill-react'
import moment from 'moment'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import React, { useState } from 'react'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'

import styles from './Dialog.module.sass'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import Datepicker from 'components/Datepicker/Datepicker'
import { translateErrorMessage } from 'hooks/useSubmitTask'

const PostponeNotification = (props) => {
	const { className, data, resolve, dismiss } = props
	const { notificationId } = data
	const { i18n, expireSession } = useGlobal()
	const [date, setDate] = useState(moment().add(1, 'days').startOf('day'))
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const handleSubmit = (e) => {
		e.preventDefault()

		if (!date.isValid()) {
			setError([i18n`Mandatory postpone date`])

			return
		}

		const url = `${API_URL}/api/notifications/${notificationId}/postpone`
		setError(null)
		setSubmitting(true)
		let formData = {
			postponeDate: date,
		}

		fetch(
			url,
			fetchOptions({
				method: 'PUT',
				body: formData,
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				resolve && resolve()
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}

				const errorMessage = translateErrorMessage(err, i18n)

				setSubmitting(false)
				setError([errorMessage])
			})
	}

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<form
				id={'form_postpone_notification'}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
			>
				<small className={styles['dialog-title']}>
					{i18n`Enter the date to postpone the notification`}
				</small>
				<fieldset>
					<Datepicker
						initialDate={moment().add(1, 'days')}
						type='date'
						text={i18n`Date`}
						onChange={(date) => {
							setDate(date)
						}}
					/>
				</fieldset>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={'form_postpone_notification'} primary>
					<small>
						<strong>
							{submitting ? i18n`Postponing` : i18n`Postpone`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default PostponeNotification
